<script>
import { mapState } from "vuex";

import cycleMixin from "@/mixins/cycleMixin";

import Stars from "@/components/_Shared/Professionals/Stars";

export default {
  mixins: [cycleMixin],

  components: {
    Stars
  },

  computed: {
    ...mapState("payable", ["payable"])
  }
};
</script>

<template>
  <div class="cycle-details">
    <h4>Detalhes do ciclo de <b>{{ payable | cycleMonth }}</b></h4>

    <div class="details">
      <p class="cycle-detail">
        <span>{{ payable | cycleOrderCount }}</span> limpezas iniciando as <span>{{ payable | cycleOrderStartsAt }}</span> com uma duração de <span>{{ payable | cycleOrderDuration }}</span> realizadas pelo(a) profissional:
      </p>

      <div class="professional">
        <img :src="payable | professionalProfilePicture" />

        <div class="professional-info">
          <p class="name">{{ payable | professionalFullName }}</p>

          <small>{{ payable | professionalTotalOrders }} limpezas</small>

          <Stars :rating="payable | professionalRating" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.cycle-details {
  border-bottom: solid 1px #e2e2e2;
  margin-bottom: 8px;
  padding-bottom: 8px;
}

h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  color: #424242;
}

b {
  font-weight: 500;
}

.professional {
  padding: 8px;
  display: flex;
  justify-content: center;
  background: #f2f2f2;
}

img {
  width: 75px;
  height: 75px;
  margin-right: 8px;
  object-fit: cover;
  border: 4px solid #f1f1f1;
  border-radius: 100%;
}

.professional-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.name {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
}

small {
  margin-top: 8px;
  font-size: 12px;
}

.cycle-detail {
  margin: 8px 0;
  font-size: 13px;
  font-weight: 300;
  color: #888;
  text-align: justify;
}

.details span {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/CheckoutMobile/Payable/CycleComponents/CycleDetails.vue